<script >

import { onMount } from 'svelte';
import { updateProduct } from "../../../../../api/Company";
import {setState, getState} from "../../../../../stores.js";

export let productArray = null;	
export let selectedProduct = null;
export let dataSaved = false;
export let submitData = false;
export let companyName = null;
export let editProduct = null;
export let openProduct = null;

let productObj = {

	name: null,
	nutritionalInfo:{},
}

var mewProductHeader = [
		{
			title: "Nutrient"
		},
		{
			title: "Mean"	
		},
		{
			title: "Lower limit"	
		},
		{
			title: "Upper limit"	
		},
		{
			title: "Units"
		}
];

let productName = null;

let nutritional = {

		Moisture: null,
		Energy_Kcal: null,
		Protein: null,
		Fat: null,
		SatFat: null,
		Carbohydrates: null,
		Sugars: null,
		Fibre: null,
		Salt: null	
}

var productNutrients = [

		{
			"key": "Moisture",
			"keyLL": "Moisture_LL",
			"keyUL": "Moisture_UL",
			"label": "Moisture",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		{
			"key": "Energy_Kcal",
			"keyLL": "Energy_Kcal_LL",
			"keyUL": "Energy_Kcal_UL",
			"label": "Energy",
			"type": "text",
			"placeholder": "Enter value",
			"units":"(kcal/100 g)",
			"required": false		
		},
		{
			"key": "Protein",
			"keyLL": "Protein_LL",
			"keyUL": "Protein_UL",
			"label": "Protein",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		{
			"key": "Fat",
			"keyLL": "Fat_LL",
			"keyUL": "Fat_UL",
			"label": "Fat",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		{
			"key": "SatFat",
			"keyLL": "SatFat_LL",
			"keyUL": "SatFat_UL",
			"label": "Sat_Fat",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		{
			"key": "Carbohydrates",
			"keyLL": "Carbohydrates_LL",
			"keyUL": "Carbohydrates_UL",
			"label": "Carbohydrates",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		{
			"key": "Sugars",
			"keyLL": "Sugars_LL",
			"keyUL": "Sugars_UL",
			"label": "Sugars",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		{
			"key": "Fibre",
			"keyLL": "Fibre_LL",
			"keyUL": "Fibre_UL",
			"label": "Fibre",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		{
			"key": "Salt",
			"keyLL": "Salt_LL",
			"keyUL": "Salt_UL",
			"label": "Salt",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		}
];

var company = null;

onMount(() => {

	var company = localStorage.getItem('company');
	company =  JSON.parse(company);
	productArray = company.Products;

	if(productArray != null && selectedProduct != null){
		
		for (const [key, value] of Object.entries(nutritional)){
			let keyLL = key + '_LL';
			let keyUL = key + '_UL';

			nutritional[keyLL] = null;
			nutritional[keyUL] = null;
		}

		for(let index = 0 ; index < productArray.length; index++ ){

			if(productArray[index].name == selectedProduct){

				for (const [key, value] of Object.entries(nutritional)){

					if(productArray[index].nutritionalInfo){

							if(productArray[index].nutritionalInfo[key]){
								nutritional[key] = productArray[index].nutritionalInfo[key];
							}
							else{
								nutritional[key] = null;
							}

					}
					else{
						nutritional[key] = null;
					}

				}


			}
			else{

			}
		}
	
				
	}

	
});

const dataChanged = () =>{

	if(dataSaved == false){

	}
	else{
		dataSaved = false;
		dataSavedRunOnce = true; 
	}
}

const saveData = () => {

	if(selectedProduct == null || productName == '' ){

		var productElement = document.getElementById('productName');
		productElement.placeholder = 'Enter a value';
	  	productElement.style.setProperty("--c", "red");
	  	productName = null;	
	  	dataSaved = false;
	  	dataSavedRunOnce = true; 
	}
	else{

		for (const [key, value] of Object.entries(nutritional)){

			if(value == null){

			}
			else{

				if(!isNaN(value)){

	  				var el = document.getElementById(key);
			  		el.placeholder = 'Enter a value';
			  		el.style.setProperty("--c", "black");

	  			}
	  			else{
	  				var el = document.getElementById(key);
			  		el.value = null;
			  		el.placeholder = 'Value should be a number';
			  		el.style.setProperty("--c", "red");
			  		dataSaved = false;
			  		dataSavedRunOnce = true; 
	  			}
			}
		}

	}
	
} 

const submit = async () => {

	var finalData = {}

	productObj.name = selectedProduct;

	for(const [key,value] of Object.entries(nutritional)){
		if(value == null){
			delete nutritional[key];
		}
	}
	productObj.nutritionalInfo = nutritional;

	finalData.CompanyName = companyName;
	finalData.Product = productObj;
	
	const res = await updateProduct(finalData);
	
	if(res.status == 'valid'){
		alert('Product added to DB!');
		dataSaved = false;
		submitData = false;
		dataSavedRunOnce = true; 
		submitDataRunOnce = true;
		setState('editProduct', false);
		setState('openProduct', false);
		setState('newProduct', false);
		window.location.reload();


	}
	else if(res.status == 'error'){
		alert('Failed to add product to DB!');
	}


	
}

var dataSavedRunOnce = true; 
var submitDataRunOnce = true;

$:{
	if(dataSaved && dataSavedRunOnce){
		dataSavedRunOnce = false
		saveData();
	}

	if(submitData && submitDataRunOnce){
		submitDataRunOnce = false;
		submit();
	}
}	




</script>

<div class="newProductContainer">
	
	<div class="productNameContainer">
		<label class="prodLabelText" for="productName">
			Product Name :
		</label>
		<input disabled bind:value={selectedProduct} class="prodInputText" type="text" id="productName" placeholder="Enter a value">
	</div>

	<div class="tableContainer">
		<div class="table">
						
				<div class="meanTableRow">
					{#each mewProductHeader as header,index}
						<div class="meanTableRowItem">
							{header.title}
						</div>
					{/each}
				</div>

					{#each productNutrients as input}
						{#if input.type != 'dummy'}
							<div class="meanTableRow">
								<div class="meanTableRowItem textOrange">{input.label}</div>
								{#if input.type == 'text'}
									<input   on:change={() => dataChanged()} bind:value={nutritional[input.key]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.key} placeholder={input.placeholder}>
								{/if}

								<input  on:change={() => dataChanged()} bind:value={nutritional[input.keyLL]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.keyLL} placeholder={input.placeholder}>
								<input  on:change={() => dataChanged()} bind:value={nutritional[input.keyUL]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.keyUL} placeholder={input.placeholder}>

								<div class="meanTableRowItem">{input.units}</div>

							</div>

						{/if}
					{/each}
		</div>
	</div>
</div>





<style >

	::placeholder{
		color: var(--c, black);
		/*opacity: 1 !important;*/
	}

	.newProductContainer{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		/*background-color: orange;*/

	}

	.productNameContainer{
		width: 40%;
		height: 10%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		gap: 1%;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);
		border-radius: 3px;
	}

	.prodLabelText{
		width: 30%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		color: var(--brand);
		opacity: 1 !important;
		margin-left: 1%;
	}

	.prodInputText{
		width: 70%;
		height: 100%;
		background-color: transparent;
		color: black;
		border: none;
		outline: none;
		border-bottom-width: 1px;
		border-bottom-color: white;
		border-bottom-style: solid;
	}

	.prodInputText:focus{
		outline: none;
	}

	.tableContainer{
		width: 100%;
		height: 90%;
		margin-top: 2%;
	}

	.table{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);
		border-radius: 3px;

	}

	.meanTableRow{
		width: 99%;
		height: 9.5%;
		display: flex;
		flex-direction: row;
		/*border-bottom-color: black;
		border-bottom-width:  0.06510416666666667vw;
		border-bottom-style: solid;*/
	}

	.meanTableRow:nth-child(even){
		background-color: rgba(33, 153, 255, 0.2);
	}


	.meanTableRowItem{
		width: 25%;
		height: 100%;
		color: black;
		display: flex;
		align-items: center;
		/*background-color: blue;*/
		font-size: 0.8463541666666666vw;
		font-weight: 700;
		/*opacity: 0.8;*/
	}
	.meanTableRowItem:nth-child(5){
		justify-content: center;	
	}

	.meanTableRow:nth-child(even){
		/*background-color:grey;*/
	}

	.tableInputText{
		height: 90%;
		background-color: transparent;
		color: black;
		border: none;
		outline: none;
	}

	.tableInputText:focus{
		outline: none;
	}
</style>